import {
  SET_ACTIVE_MODEL,
  SET_ACTIVE_ADMIN_MODEL,
  RESET_STATE,
  RESET_OMM_STATE,
  SET_MODEL_DATES,
  SET_FORECAST_MODEL_DATES,
  SET_END_DATE_AND_INDEX,
  SET_FORECAST_END_DATE,
  SET_START_DATE_AND_INDEX,
  SET_MEDIA,
  SET_MIN_MAX_MEDIA,
  SET_CHOOSEN_MEDIA_RANGE,
  SET_EXECUTIVE_MMM_DATA,
  SET_ROAS_PROJECTIONS_MMM_DATA,
  SET_ADSTOCK_IMPACT,
  SET_OMM_DATA,
  SET_OMM_GRAPH_DATA,
  SET_GROUPING_VALUE,
  SET_TOGGLES_TARGETS,
  SET_FEATURES,
  SET_TITLE,
  SET_MMM_DATA_AFTER_TOGGLE_UPDATE,
  SET_COMPARED_MEDIA,
  SET_FORECAST_RANGE,
  SET_PROMOTION_SLIDER_INFO,
  SET_METRIC,
  SET_MODEL_BUILD_DATE,
  SET_CATEGORIES,
  SET_SELECTED_CATEGORIES,
  SET_VERSION,
  SET_SYNERGY,
  SET_EXCHANGE_RATES,
  SET_CURRENCY,
  SET_PREFIX_SYMBOLS,
  SET_MEDIA_ENTITIES,
  SET_WORKFLOW_ID,
  SET_WORKFLOW_COMPLETE,
  SET_EXPORT_INTEGRATIONS,
} from '../types';

export default (state, action) => {
  switch (action.type) {
    case SET_MODEL_DATES: {
      return {
        ...state,
        minDate: action.payload.minDate,
        maxDate: action.payload.maxDate,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
        endIndex: action.payload.endIndex,
      };
    }

    case SET_FORECAST_MODEL_DATES: {
      return {
        ...state,
        forecastMinDate: action.payload.forecastMinDate,
        forecastMaxDate: action.payload.forecastMaxDate,
        forecastEndDate: action.payload.forecastEndDate,
      };
    }

    case SET_EXECUTIVE_MMM_DATA: {
      return {
        ...state,
        roasData: action.payload.roas || state.roasData,
        weeklyData: action.payload?.breakdown || state.weeklyData,
        salesData: action.payload.sales_graph || state.salesData,
        medias: action.payload.sales_graph?.medias || state.medias,
        grouping: action.payload.hidden || null,
      };
    }

    case SET_ROAS_PROJECTIONS_MMM_DATA: {
      return {
        ...state,
        roiData: action.payload.curves || state.roiData,
        campaignCurve: action.payload.campaignCurve || state.campaignCurve,
      };
    }

    case SET_ADSTOCK_IMPACT: {
      return {
        ...state,
        adstockImpact: action.payload,
      };
    }

    case SET_OMM_DATA: {
      return {
        ...state,
        ommData: action.payload.bounds,
        ommMax: action.payload.global_max,
        ommMin: action.payload.global_min,
      };
    }

    case SET_OMM_GRAPH_DATA: {
      return {
        ...state,
        ommGraphData: action.payload,
      };
    }

    case SET_ACTIVE_MODEL: {
      return {
        ...state,
        activeModel: action.payload,
      };
    }

    case SET_ACTIVE_ADMIN_MODEL: {
      return {
        ...state,
        activeAdminModel: action.payload,
      };
    }

    case SET_START_DATE_AND_INDEX: {
      return {
        ...state,
        startDate: action.payload.startDate,
        startIndex: action.payload.startIndex,
      };
    }

    case SET_END_DATE_AND_INDEX: {
      return {
        ...state,
        endDate: action.payload.endDate,
        endIndex: action.payload.endIndex,
      };
    }

    case SET_FORECAST_END_DATE: {
      return {
        ...state,
        forecastEndDate: action.payload,
      };
    }

    case SET_MEDIA: {
      return {
        ...state,
        filterMedia: action.payload,
      };
    }

    case SET_MIN_MAX_MEDIA: {
      return {
        ...state,
        filterMediaMinMax: action.payload,
      };
    }

    case SET_CHOOSEN_MEDIA_RANGE: {
      return {
        ...state,
        filterMediaChoosenRange: action.payload,
      };
    }

    case SET_TOGGLES_TARGETS: {
      return {
        ...state,
        toggleTargets: action.payload,
      };
    }

    case SET_GROUPING_VALUE: {
      return {
        ...state,
        groupingValue: {
          ...state.groupingValue,
          [action.payload.key]: action.payload[action.payload.key],
        },
      };
    }

    case SET_FEATURES: {
      return {
        ...state,
        features: action.payload,
      };
    }

    case SET_TITLE: {
      return {
        ...state,
        title: action.payload,
      };
    }

    case SET_COMPARED_MEDIA: {
      return {
        ...state,
        comparedMedia: action.payload,
      };
    }

    case SET_FORECAST_RANGE: {
      return {
        ...state,
        forecastRange: action.payload,
      };
    }

    case SET_SYNERGY: {
      return {
        ...state,
        synergy: action.payload,
      };
    }

    case 'SET_SYNERGY_NEW': {
      return {
        ...state,
        synergyNew: action.payload,
      };
    }

    case 'SET_SYNERGY_DELTA': {
      return {
        ...state,
        synergyDelta: action.payload,
      };
    }

    case SET_EXCHANGE_RATES: {
      return {
        ...state,
        exchangeRates: action.payload,
      };
    }

    case SET_CURRENCY: {
      return {
        ...state,
        currency: action.payload,
      };
    }

    case SET_PREFIX_SYMBOLS: {
      return {
        ...state,
        prefixSymbols: action.payload,
      };
    }

    case SET_PROMOTION_SLIDER_INFO: {
      return {
        ...state,
        promotionSliderInfo: action.payload,
      };
    }

    case SET_MEDIA_ENTITIES: {
      return {
        ...state,
        mediaEntities: action.payload,
      };
    }

    case SET_VERSION: {
      return {
        ...state,
        version: action.payload,
      };
    }

    case SET_MMM_DATA_AFTER_TOGGLE_UPDATE: {
      return {
        ...state,
        features: action.payload.updatedFeatures,
        roasData: action.payload.updatedRoas,
        salesData: action.payload.updatedSalesData,
        medias: action.payload.updatedMediaList,
        roiData: action.payload.updatedRoi,
        weeklyData: action.payload.updatedWeeklyData,
      };
    }

    case SET_METRIC: {
      return {
        ...state,
        metric: action.payload,
      };
    }

    case SET_MODEL_BUILD_DATE: {
      return {
        ...state,
        modelBuildDate: action.payload,
      };
    }

    case SET_CATEGORIES: {
      return {
        ...state,
        categories: action.payload,
      };
    }

    case SET_SELECTED_CATEGORIES: {
      return {
        ...state,
        selectedCategories: action.payload,
      };
    }

    case SET_WORKFLOW_ID: {
      return {
        ...state,
        workflowId: action.payload,
      };
    }

    case SET_WORKFLOW_COMPLETE: {
      return {
        ...state,
        workflowCompleted: action.payload,
      };
    }

    case SET_EXPORT_INTEGRATIONS: {
      return {
        ...state,
        exportIntegrations: action.payload,
      };
    }

    case RESET_STATE: {
      return {
        ...action.payload,
        activeModel: state.activeModel,
      };
    }

    case RESET_OMM_STATE: {
      return {
        ...state,
        ommData: action.payload.ommData,
        ommGraphData: action.payload.ommGraphData,
      };
    }

    default:
      return state;
  }
};
